import {
  HELPFIND_PHONE,
  HELPFIND_PHONE_HH,
  HELPFIND_PHONE_PIT,
  HELPFIND_PHONE_TRANSMISSION,
  PRODUCT,
} from '@/consts';

const getHelpfindPhone = (productId?: number) => {
  if (productId === PRODUCT.HOUSE_HOLD) {
    return HELPFIND_PHONE_HH;
  }
  if (productId === PRODUCT.PIT) {
    return HELPFIND_PHONE_PIT;
  }
  if (productId === PRODUCT.TRANSMISSION) {
    return HELPFIND_PHONE_TRANSMISSION;
  }
  return HELPFIND_PHONE;
};

export default getHelpfindPhone;
